import {
  HttpClient,
  HttpErrorResponse,
  HttpEventType,
  HttpResponse,
} from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  ReportFile,
  ReportFileStatus,
  ReportFileType,
} from 'src/app/core/models/reportFile';
import {
  ReportFleet,
  ReportFleetFilter,
  ReportFleetFilterSelect,
} from 'src/app/core/models/reportFleet';
import { AuthService } from 'src/app/core/services/auth.service';
import { ReportService } from 'src/app/core/services/report.service';
import { ToastService } from 'src/app/shared/widget/notification/toast-service';
import { saveAs } from 'file-saver';
import { DatePipe } from '@angular/common';
import { catchError, map, take, takeUntil } from 'rxjs/operators';
import { GoogleMap } from '@angular/google-maps';
import { Observable, of } from 'rxjs';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { Loader } from '@googlemaps/js-api-loader';
import { Icon } from 'leaflet';
@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
  providers: [DatePipe],
})
export class ReportComponent implements OnInit {
  constructor(
    public reportService: ReportService,
    public toastService: ToastService,
    private authService: AuthService,
    public datePipe: DatePipe,
    public modalService: NgbModal
  ) {
    this.userEmail = this.authService.currentUserValue.email;
  }
  options: google.maps.MapOptions = {
    center: { lat: -13.7972945, lng: -59.6173487 },
    zoom: 4,
  };

  loader = new Loader({
    apiKey: environment.googleMaps.key,
    version: 'weekly',
  });
  maps: any;

  userEmail: string;
  circularProgressiveWait: boolean = false;
  // reportFiles: ReportFile[] = [];
  // reportFileStatusEnum: any = ReportFileStatus;
  // reportFileTypeEnum: any = ReportFileType;
  // lastPositionFile: any[] = [];

  circularProgressiveWaitReportLastPositions: boolean = false;

  // Report fleet
  circularProgressiveWaitTabFleet: number = -1;
  circularProgressiveWaitTabFleetText: string = '';
  reportFleet: ReportFleet[] = [];
  reportFleetMarkers: google.maps.Marker[] = [];
  reportFleetFilter: ReportFleetFilter = new ReportFleetFilter();
  reportFleetFilterLatLngBool: boolean = false;
  reportFleetFilterLatLngRadius: number = 1000;
  reportFleetFilterLatLngMarker: any;
  reportFleetFilterLatLng: { lat: number; lng: number } = {
    lat: 0,
    lng: 0,
  };
  reportFleetFilterSelect: ReportFleetFilterSelect =
    new ReportFleetFilterSelect();
  markerClusterer: any;

  // Summarized Positions
  circularProgressiveWaitSummarizedPositions: boolean = false;
  reportSummarizedPositionsListFilter: {
    fileName: string;
    size: number;
    yearMonth?: string;
  }[] = [];
  reportSummarizedPositionsList: {
    fileName: string;
    size: number;
    yearMonth?: string;
  }[] = [];
  reportSummarizedPositionsListMonth: string[] = [];
  reportSummarizedPositionsFile: any;
  seriaisSummarizedPositionSearch: { fileName: string; seriais: string } = {
    fileName: '',
    seriais: '',
  };
  filterSummarizedPositionsYear: { year: string }[] = [];
  filterSummarizedPositionsMonth: { month: string }[] = [];
  filterSummarizedPositionsYearSelect: string | undefined = undefined;
  filterSummarizedPositionsMonthSelect: string | undefined = undefined;

  reportSummarizedPositionsSearch: string[] = [];

  private async initializeMap() {
    await this.loader.importLibrary('visualization');
    const { Map } = (await google.maps.importLibrary(
      'maps'
    )) as google.maps.MapsLibrary;

    this.maps = new Map(
      document.getElementById('map') as HTMLElement,
      this.options
    );
  }

  ngOnInit(): void {}

  /*
   * Get last position simple MySql
   */

  changeUseMapPoint() {
    if (!this.reportFleetFilterLatLngBool) {
      if (this.reportFleetFilterLatLngMarker) {
        this.reportFleetFilterLatLngMarker.setMap(null);
        this.createMarkersFleet(false);
      }
    } else {
      this.clickMapFleet();
    }
  }

  clickMapFleet() {
    this.maps.addListener('click', (mapsMouseEvent: any) => {
      this.reportFleetFilterLatLng = {
        lat: mapsMouseEvent.latLng.lat(),
        lng: mapsMouseEvent.latLng.lng(),
      };
    });
    if (this.reportFleetFilterLatLngMarker) {
      this.reportFleetFilterLatLngMarker.setMap(null);
    }
    if (
      this.reportFleetFilterLatLng.lat != 0 &&
      this.reportFleetFilterLatLng.lng != 0
    ) {
      const markerCircle = new google.maps.Circle({
        center: new google.maps.LatLng(this.reportFleetFilterLatLng),

        radius: this.reportFleetFilterLatLngRadius,
        draggable: true,
        strokeColor: '#3e1451',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#FFFFFF',
        fillOpacity: 0.35,
      });

      markerCircle.addListener('dragend', (mapsMouseEvent: any) => {
        this.reportFleetFilterLatLng = {
          lat: markerCircle.getCenter()?.lat() ?? 0,
          lng: markerCircle.getCenter()?.lng() ?? 0,
        };
        this.reportFleet.length > 0 ? this.createMarkersFleet(false) : null;
      });

      this.maps.setCenter(markerCircle.getCenter());
      this.maps.setZoom(14);
      this.reportFleetFilterLatLngMarker = markerCircle;
      this.reportFleetFilterLatLngMarker.setMap(this.maps);
    }
    this.reportFleetFilterLatLngBool
      ? this.reportFleet.length > 0
        ? this.createMarkersFleet(false)
        : null
      : null;
  }
  getReportFleetFilter() {
    this.reportService.requestFleetFilter().subscribe((response: any) => {});
  }

  getReportFleet() {
    this.initializeMap();
    this.reportFleet = [];
    let sizeComplete = 2000000;
    this.circularProgressiveWaitTabFleet = 1;

    this.circularProgressiveWaitTabFleetText = 'Buscandos os dados';
    this.reportService.requestFleet().subscribe((event: any) => {
      if (event.type === HttpEventType.DownloadProgress) {
        const percentDone = event.total
          ? Math.round((100 * event.loaded) / event.total)
          : 0;
        this.circularProgressiveWaitTabFleet = percentDone;
      }
      if (event.type === HttpEventType.Response) {
        this.reportFleet = event.body;
        //      this.reportService.requestFleetFilter().subscribe((response: any) => {
        //        this.reportFleetFilter = response;
        //     });
        this.clickMapFleet();
        this.createMarkersFleet(true);
        this.circularProgressiveWaitTabFleet = -1;
        this.circularProgressiveWaitTabFleetText = '';
      }
    });
  }

  filterFirst(
    item: ReportFleet,
    index: ReportFleetFilterIndex
  ): ReportFleetFilterIndex {
    index.indexMarca = this.reportFleetFilter.marca.findIndex(
      (itemFilter: any) => {
        return itemFilter.name == item.marca;
      }
    );
    index.indexModelo = this.reportFleetFilter.modelo.findIndex(
      (itemFilter: any) => {
        return itemFilter.name == item.modelo;
      }
    );
    index.indexUf = this.reportFleetFilter.uf.findIndex((itemFilter: any) => {
      return itemFilter.name == item.revGeoUF;
    });
    index.indexMunicipio = this.reportFleetFilter.municipio.findIndex(
      (itemFilter: any) => {
        return itemFilter.name == item.revGeoMunicipio;
      }
    );
    index.indexBairro = this.reportFleetFilter.bairro.findIndex(
      (itemFilter: any) => {
        return itemFilter.name == item.revGeoBairro;
      }
    );
    if (this.reportFleetFilterLatLngBool) {
      index.indexInsidePoint = this.filterByPoint(
        new google.maps.LatLng({
          lat: Number(item.gpsLatitude),
          lng: Number(item.gpsLongitude),
        }),
        new google.maps.LatLng(this.reportFleetFilterLatLng),
        this.reportFleetFilterLatLngRadius
      )
        ? 1
        : -1;
    }
    return index;
  }

  filterSelect(item: ReportFleet, index: any) {
    let indexFilterAux: any;
    if (this.reportFleetFilterSelect.marca.length > 0) {
      indexFilterAux = this.reportFleetFilter.marca.filter(
        (itemFilter: any) => {
          if (itemFilter.name == item.marca) {
            return itemFilter.id;
          }
        }
      )[0];

      index.indexMarca = this.reportFleetFilterSelect.marca.findIndex(
        (itemFilter: any) => {
          return itemFilter == indexFilterAux.id;
        }
      );
    }
    if (this.reportFleetFilterSelect.modelo.length > 0) {
      indexFilterAux = this.reportFleetFilter.modelo.filter(
        (itemFilter: any) => {
          if (itemFilter.name == item.modelo) {
            return itemFilter.id;
          }
        }
      )[0];

      index.indexModelo = this.reportFleetFilterSelect.modelo.findIndex(
        (itemFilter: any) => {
          return itemFilter == indexFilterAux.id;
        }
      );
    }
    if (this.reportFleetFilterSelect.uf.length > 0) {
      indexFilterAux = this.reportFleetFilter.uf.filter((itemFilter: any) => {
        if (itemFilter.name == item.revGeoUF) {
          return itemFilter.id;
        }
      })[0];

      index.indexUf = this.reportFleetFilterSelect.uf.findIndex(
        (itemFilter: any) => {
          return itemFilter == indexFilterAux.id;
        }
      );
    }
    if (this.reportFleetFilterSelect.municipio.length > 0) {
      indexFilterAux = this.reportFleetFilter.municipio.filter(
        (itemFilter: any) => {
          if (itemFilter.name == item.revGeoMunicipio) {
            return itemFilter.id;
          }
        }
      )[0];

      index.indexMunicipio = this.reportFleetFilterSelect.municipio.findIndex(
        (itemFilter: any) => {
          return itemFilter == indexFilterAux.id;
        }
      );
    }
    if (this.reportFleetFilterSelect.bairro.length > 0) {
      indexFilterAux = this.reportFleetFilter.bairro.filter(
        (itemFilter: any) => {
          if (itemFilter.name == item.revGeoBairro) {
            return itemFilter.id;
          }
        }
      )[0];

      index.indexBairro = this.reportFleetFilterSelect.bairro.findIndex(
        (itemFilter: any) => {
          return itemFilter == indexFilterAux.id;
        }
      );
    }
    if (this.reportFleetFilterLatLngBool) {
      index.indexInsidePoint = this.filterByPoint(
        new google.maps.LatLng({
          lat: Number(item.gpsLatitude),
          lng: Number(item.gpsLongitude),
        }),
        new google.maps.LatLng(this.reportFleetFilterLatLng),
        this.reportFleetFilterLatLngRadius
      )
        ? 1
        : -1;
    }
    return index;
  }

  prepareFilter(item: ReportFleet, index: any) {
    if (index.indexMarca < 0) {
      this.reportFleetFilter.marca.push({
        id: this.reportFleetFilter.marca.length,
        name: item.marca,
      });
    }

    if (index.indexModelo < 0) {
      this.reportFleetFilter.modelo.push({
        id: this.reportFleetFilter.modelo.length,
        name: item.modelo,
      });
    }

    if (index.indexUf < 0) {
      this.reportFleetFilter.uf.push({
        id: this.reportFleetFilter.uf.length,
        name: item.revGeoUF,
      });
    }

    if (index.indexMunicipio < 0) {
      this.reportFleetFilter.municipio.push({
        id: this.reportFleetFilter.municipio.length,
        name: item.revGeoMunicipio,
      });
    }

    if (index.indexBairro < 0) {
      this.reportFleetFilter.bairro.push({
        id: this.reportFleetFilter.bairro.length,
        name: item.revGeoBairro,
      });
    }
  }

  filterByPoint(
    gpsLatLng: google.maps.LatLng,
    point: google.maps.LatLng,
    radius: number
  ) {
    return (
      google.maps.geometry.spherical.computeDistanceBetween(point, gpsLatLng) <
      radius
    );
  }

  createMarkersFleet(firstSearch: boolean) {
    this.circularProgressiveWaitTabFleet = 1;
    try {
      this.markerClusterer.clearMarkers();
    } catch (error) {}
    if (firstSearch && !this.reportFleetFilterLatLngBool) {
      this.circularProgressiveWaitTabFleetText = 'Gerando os marcadores';
    } else {
      this.circularProgressiveWaitTabFleetText =
        'Filtrando os dados e gerando os marcadores ';
    }
    this.reportFleetMarkers = [];
    const infoWindow = new google.maps.InfoWindow({
      content: '',
      disableAutoPan: true,
    });
    this.reportFleet.forEach((item: ReportFleet) => {
      let index: ReportFleetFilterIndex = new ReportFleetFilterIndex();
      if (firstSearch) {
        index = this.filterFirst(item, index);
        this.prepareFilter(item, index);
      } else {
        index = this.filterSelect(item, index);
      }
      let filterPass = [];
      this.reportFleetFilterSelect.marca.length > 0
        ? filterPass.push(index.indexMarca > -1)
        : false;
      this.reportFleetFilterSelect.modelo.length > 0
        ? filterPass.push(index.indexModelo > -1)
        : false;
      this.reportFleetFilterSelect.bairro.length > 0
        ? filterPass.push(index.indexBairro > -1)
        : false;
      this.reportFleetFilterSelect.municipio.length > 0
        ? filterPass.push(index.indexMunicipio > -1)
        : false;
      this.reportFleetFilterSelect.uf.length > 0
        ? filterPass.push(index.indexUf > -1)
        : false;
      this.reportFleetFilterLatLngBool
        ? filterPass.push(index.indexInsidePoint > -1)
        : false;

      let filterFalse =
        filterPass.findIndex((aux: any) => {
          return aux == false;
        }) > -1
          ? false
          : true;

      if ((firstSearch && !this.reportFleetFilterLatLngBool) || filterFalse) {
        const infowindow = new google.maps.InfoWindow({
          content: ` <div style="line-height: 0.5;">
          <br></br>
          <p><span style="color: #ff0000;"><strong>${item.dataHoraEvento}</strong></span></p>
          <p><strong>Marca:</strong> ${item.marca}</p>
          <p><strong>Modelo:</strong> ${item.modelo}</p>
          <p><strong>Chassi:</strong> ${item.chassi}</p>
         
          <p><strong>Origem:</strong> ${item.origemDispositivo}</p>
          </div>
          `,
        });
        //<p><strong>Placa:</strong> ${item.placa}</p>
        var customIcon = {
          url: 'data:image/svg+xml,<?xml version="1.0" encoding="UTF-8" standalone="no"?><svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 5 5"><circle cx="2.5" cy="2.5" r="2" fill="red" /></svg>',
          scaledSize: new google.maps.Size(5, 5),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(15, 15),
        };
        const marker = new google.maps.Marker({
          position: {
            lat: Number(item.gpsLatitude),
            lng: Number(item.gpsLongitude),
          },
          optimized: true,
          draggable: false,
          clickable: false,
          icon: customIcon,
        });
        // this.reportFleetFilterLatLngBool
        //   ? marker.addListener('click', () => {
        //       infowindow.open({
        //         anchor: marker,
        //         shouldFocus: false,
        //       });
        //     })
        //   : null;
        marker.setMap(this.maps);
        this.reportFleetMarkers.push(marker);
      }
    });

    // let clusterOptions = {
    //   map: this.maps,
    //   markers: this.reportFleetMarkers,
    //   // gridSize: 40,
    //   //  maxZoom: 13,
    //   // zoomOnClick: false,
    //   //    minimumClusterSize: 2,
    //   //  renderer?: Renderer;
    //   //  onClusterClick?: onClusterClickHandler;
    // };

    // this.markerClusterer = new MarkerClusterer(clusterOptions);

    /*   markerClusterer.setMap(this.maps);
    google.maps.event.addListener(
      markerClusterer,
      'clusterclick',
      (cluster: any) => {
        this.maps.setCenter(markerClusterer.getMap()?.getZoom);
        this.maps.setZoom(this.maps.getZoom() + 1);
      }
    );*/
    this.circularProgressiveWaitTabFleet = -1;
    this.circularProgressiveWaitTabFleetText = '';
  }

  //Export Excel
  exportExcelJson(nameFile: string, data: any) {
    this.circularProgressiveWaitTabFleet = -1;

    import('xlsx')
      .then((xlsx) => {
        const worksheet = xlsx.utils.json_to_sheet(data);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, {
          bookType: 'xlsx',
          type: 'array',
        });
        this.saveAsExcelFile(
          excelBuffer,
          `${nameFile}_${this.datePipe.transform(
            new Date(),
            'yyyy-MM-ddTHH:mm:ss'
          )}`
        );
      })
      .then(() => {
        this.circularProgressiveWaitTabFleet = 0;
      });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let currentDate = new Date();
    let month: number = currentDate.getMonth() + 1;
    let day: number = currentDate.getDate();
    let year: number = currentDate.getFullYear();
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + year + month + day + EXCEL_EXTENSION
      );
    });
  }

  /*
   * Get last position elastic
   */
  // getListFiles() {
  //   this.circularProgressiveWait = true;
  //   this.reportFiles = [];
  //   this.reportService.getListFiles(1).subscribe((response: any) => {
  //     this.lastPositionFile = response;
  //     this.circularProgressiveWait = false;
  //   });
  // }

  // requestFile(fileTypeId: number) {
  //   this.reportService.requestReportFiles(fileTypeId, this.userEmail);

  // .subscribe((response: string) => {
  //   if (response == '') {
  //     this.toastService.show('Arquivo solicitado com sucesso', {
  //       classname: 'bg-success text-center text-white',
  //       delay: 2500,
  //     });
  //   } else {
  //     this.toastService.show(response, {
  //       classname: 'bg-warning text-center text-white',
  //       delay: 10000,
  //     });
  //   }
  // },
  // (error: HttpErrorResponse) => {
  //   this.toastService.show(
  //     'Erro ao requisitar arquivo',
  //     {
  //       classname: 'bg-danger text-center text-white',
  //       delay: 10000,
  //     }
  //   );
  // });

  downloadFile(fileTypeId: number) {
    this.circularProgressiveWaitReportLastPositions = true;
    this.reportService
      .requestReportFile(fileTypeId, this.userEmail)
      .pipe(take(1))
      .subscribe(
        (response: any) => {
          if (response != null) {
            this.reportService.downloadReportFilesOpen(response);
          }

          this.circularProgressiveWaitReportLastPositions = false;
        },
        (error: HttpErrorResponse) => {
          this.toastService.show(
            'Erro ao solicitar arquivo - ' + error.message,
            {
              classname: 'bg-danger text-center text-white',
              delay: 10000,
            }
          );
          this.circularProgressiveWaitReportLastPositions = false;
        }
      );
    // });
    // .catch((err: any) => {
    //   this.circularProgressiveWaitReportLastPositions = false;
    // })
    // .then((res: any) => {
    //   const filename = `ultima-posicao-elastic_${new Date().toLocaleString()}.csv`;
    //   let blob = new Blob([res], { type: 'text/csv' });
    //   saveAs(blob, filename);
    //   this.circularProgressiveWaitReportLastPositions = false;
    // })
    // .catch((err: any) => {
    //   this.circularProgressiveWaitReportLastPositions = false;

    //   alert('Error ao fazer download');
    //   console.error(err);
    // });
    // this.reportService
    //   .requestReportFilesAsync(fileTypeId, this.userEmail)
    //   .then((res: any) => {
    //     const filename = `ultima-posicao-elastic_${new Date().toLocaleString()}.csv`;
    //     let blob = new Blob([res], { type: 'text/csv' });
    //     saveAs(blob, filename);
    //     this.circularProgressiveWaitReportLastPositions = false;
    //   })
    //   .catch((err: any) => {
    //     this.circularProgressiveWaitReportLastPositions = false;

    //     alert('Error ao fazer download');
    //     console.error(err);
    //   });
  }

  // downloadFile(fileName: string) {
  //   this.reportService.downloadFile(fileName, this.userEmail);
  // }

  requestDownload(fileName: string) {}

  round(num: number, fractionDigits: number): number {
    return Number(num.toFixed(fractionDigits));
  }

  /*
   * Get Summarized Positions
   */

  filterSummarizedPosition() {
    this.reportSummarizedPositionsListFilter =
      this.reportSummarizedPositionsList.filter((item: any) => {
        return (
          item.yearMonth ==
          `${this.filterSummarizedPositionsYearSelect}-${this.filterSummarizedPositionsMonthSelect}`
        );
      });
  }

  requestSummarizedPositionsList() {
    this.circularProgressiveWaitSummarizedPositions = true;
    this.reportService.getReportSummarizedPositions().subscribe(
      (response: any) => {
        this.reportSummarizedPositionsList = response;
        this.reportSummarizedPositionsList.forEach((item: any) => {
          let itemSplit = item.fileName.split('/');
          let yearMonth = itemSplit[itemSplit.length - 2] ?? '';
          item.yearMonth = yearMonth;
          let year = yearMonth.split('-')[0];
          let month = yearMonth.split('-')[1];
          let indexMonth = this.filterSummarizedPositionsMonth.findIndex(
            (monthItem: any) => {
              return monthItem.month == month;
            }
          );
          let indexYear = this.filterSummarizedPositionsYear.findIndex(
            (yearItem: any) => {
              return yearItem.year == year;
            }
          );
          if (indexYear == -1) {
            this.filterSummarizedPositionsYear.push({
              year: year,
            });
          }
          if (indexMonth == -1) {
            this.filterSummarizedPositionsMonth.push({
              month: month,
            });
          }
        });

        this.filterSummarizedPositionsMonthSelect =
          this.filterSummarizedPositionsMonth[1].month ?? undefined;
        this.filterSummarizedPositionsYearSelect =
          this.filterSummarizedPositionsYear[1].year ?? undefined;

        this.filterSummarizedPosition();

        this.circularProgressiveWaitSummarizedPositions = false;
      },
      (error: HttpErrorResponse) => {
        this.toastService.show(
          'Erro ao solicitar lista de arquivos - ' + error.message,
          {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          }
        );
        this.circularProgressiveWaitSummarizedPositions = false;
      }
    );
  }
  requestSummarizedPositionsListFile(fileName: string) {
    this.circularProgressiveWaitSummarizedPositions = true;
    var progress;
    this.reportService
      .getReportSummarizedPositionsFileUrl(fileName)
      .subscribe((data: any) => {
        const blob = new Blob([data], { type: 'application/octet-stream' });
        const fileName = 'data.csv';
        saveAs(data.blob, data.fileName); // save file from blob

        this.circularProgressiveWaitSummarizedPositions = false;
      });
  }

  openModalSummarizedPositionSeriaisSearch(
    centerDataModal: any,
    fileName: any
  ) {
    this.seriaisSummarizedPositionSearch.fileName = fileName;
    this.modalService.open(centerDataModal, {
      centered: true,
      windowClass: 'modal-holder',
    });
  }

  requestSummarizedPositionsListSerialSearch() {
    this.circularProgressiveWaitSummarizedPositions = true;
    this.reportSummarizedPositionsSearch = [];
    this.reportService
      .getReportSummarizedPositionsSerialSearch(
        this.seriaisSummarizedPositionSearch
      )
      .subscribe(
        (response: any) => {
          this.reportSummarizedPositionsSearch = response;
          this.circularProgressiveWaitSummarizedPositions = false;
        },
        (error: HttpErrorResponse) => {
          this.toastService.show(
            'Erro ao pesquisar seraiis - ' + error.message,
            {
              classname: 'bg-danger text-center text-white',
              delay: 10000,
            }
          );
          this.circularProgressiveWaitSummarizedPositions = false;
        }
      );
  }
}

export class ReportFleetFilterIndex {
  indexMarca: number;
  indexModelo: number;
  indexBairro: number;
  indexMunicipio: number;
  indexUf: number;
  indexInsidePoint: number;

  constructor() {
    (this.indexMarca = -1),
      (this.indexModelo = -1),
      (this.indexBairro = -1),
      (this.indexMunicipio = -1),
      (this.indexUf = -1);
    this.indexInsidePoint = -1;
  }
}
